import { memo } from "react";
import "./QuotationRoomLabel.scss";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import RoomCapacity from "app/pages/.shared/RoomCapacity.jsx";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import Badge from "app/pages/.shared/Badge.jsx";
import { FormattedMessage } from "react-intl";

const QuotationRoomLabel = ({ rooms, price, isIncluded, stressMarketingLabel }) => {
	return (
		<>
			<div className="quotation-room-label">
				<div className="quotation-room-label__title">
					{rooms?.map((room, index) => (
						<div
							key={`${room.title}-${index}`}
							className="quotation-room-label__room"
							data-testid="room-label"
						>
							<Typography
								className="quotation-room-label__room-description"
								variant={TYPOGRAPHY_VARIANTS.LARGE}
								component="p"
							>
								<Typography
									className="quotation-room-label__quantity"
									variant={TYPOGRAPHY_VARIANTS.LARGE}
									isBold
									component="span"
								>
									{room.quantity}x{" "}
								</Typography>
								{room.title}{" "}
								<Typography
									variant={TYPOGRAPHY_VARIANTS.LARGE}
									component="span"
									className="quotation-room-label__room-details"
								>
									{room?.area?.value > 0 &&
										`[${room.area.value} ${room?.area?.unit}]`}{" "}
									{Object.keys(room?.occupancy)?.length > 0 && (
										<RoomCapacity
											adultCount={room.occupancy?.adults}
											babyCount={room.occupancy?.babies}
											childCount={room.occupancy?.children}
										/>
									)}
								</Typography>
							</Typography>
						</div>
					))}
				</div>

				{isIncluded ? (
					<Badge>
						<FormattedMessage id="general.included" />
					</Badge>
				) : (
					<AmountContainer
						className="quotation-room-label__price"
						amount={price}
						prefix={<AmountSign sign="+" />}
					/>
				)}
			</div>

			{stressMarketingLabel && (
				<div className="quotation-room-label__stress-marketing">{stressMarketingLabel}</div>
			)}
		</>
	);
};

QuotationRoomLabel.propTypes = {
	rooms: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			quantity: PropTypes.number.isRequired,
			title: PropTypes.string.isRequired,
			area: PropTypes.shape({
				value: PropTypes.number,
				unit: PropTypes.string,
			}).isRequired,
			occupancy: PropTypes.shape({
				adults: PropTypes.number,
				children: PropTypes.number,
				babies: PropTypes.number,
			}),
		})
	).isRequired,
	price: PropTypes.number,
	isIncluded: PropTypes.bool,
	stressMarketingLabel: PropTypes.string,
};

export default memo(QuotationRoomLabel);
